module.exports = __webpack_public_path__ + "img/cimen.fdb8f5b7.png";